import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueConverters, FieldValueFormatter, FieldValueParser, LookupValueFormatter } from './FieldValueConverters'
import Cascader from 'rc-cascader'
import { Input } from 'reactstrap'

class CascaderBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array,
    valueProp: pt.string,
    textProp: pt.string,
    childrenProp: pt.string
  })

  static defaultProps = {
    valueProp: 'Value',
    textProp: 'Text',
    childrenProp: 'Children',
    options: []
  }

  render () {
    const { options, valueProp, textProp, childrenProp, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ testId, showError, value, name, onChange, placeHolder, loading, readonly }) => {
          const dv = LookupValueFormatter(options, value, valueProp, textProp, childrenProp)
          if ((options || []).length > 0) {
            if (readonly) {
              return <Input data-tid={testId} name={`view${name}`} id={`view${name}`} value={dv.Text} readOnly />
            } else {
              return <Cascader name={`cascader${name}`} id={`cascader${name}`} options={options || []} defaultValue={dv.Keys} fieldNames={{ label: textProp, value: valueProp, children: childrenProp }}
                onChange={onChange}>
                <Input data-tid={testId} name={`cascader_text${name}`} id={`cascader_text${name}`} value={dv.Text} placeholder={placeHolder} />
              </Cascader>
            }
          } else {
            return <Input data-tid={testId} name={`cascader_text${name}`} id={`cascader_text${name}`} readOnly placeholder={placeHolder} />
          }
        }}
      </FieldLayoutBox>
    )
  }
}

export const CascaderBox = ({ parse, format, fieldType = FieldValueConverters.CascaderData, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={CascaderBoxClass} /> } // eslint-disable-line
export default CascaderBox
